// スタイルシートを読み込む
import "./index.scss";

//BootstrapのJavaScript側の機能を読み込む
//import "bootstrap";

// import Swiper JS
// import Swiper from 'swiper/bundle'; // 全ての機能が入っている


import "./main.js";

//import topimage_general from './img/topimage_general.png';
//import Logo from './img/logo.svg';

// import iconLogin from './img/icon-login.png';
// import iconTel from './img/icon-tel.png';
// import logo from './img/logo.png';
// import iconFacebook from './img/icon-facebook.png';
// import iconInstagram from './img/icon-instagram.png';
// import bannerLine from './img/banner-line.png';